import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-280dfbe9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notification is-warning" }, [
  /*#__PURE__*/_createElementVNode("span", null, "No elements to display.")
], -1))
const _hoisted_2 = {
  key: 1,
  class: "columns is-multiline"
}
const _hoisted_3 = { class: "table centered-table is-fullwidth is-hoverable" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "is-two-third-table" }, "Name", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Type", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "is-narrow"
}
const _hoisted_8 = {
  key: 2,
  class: "columns is-multiline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElementInLine = _resolveComponent("ElementInLine")!
  const _component_ElementThumbnail = _resolveComponent("ElementThumbnail")!

  return (!_ctx.elements.length)
    ? _renderSlot(_ctx.$slots, "no-results", { key: 0 }, () => [
        _hoisted_1
      ], true)
    : (_ctx.elementsTableLayout || _ctx.asTable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_4,
                _hoisted_5,
                (_ctx.hasClasses && _ctx.displayElementClasses)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_6, "Classes"))
                  : _createCommentVNode("", true),
                (!_ctx.disabled)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Actions"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element) => {
                return (_openBlock(), _createBlock(_component_ElementInLine, {
                  key: element.id,
                  element: element,
                  disabled: _ctx.disabled
                }, null, 8, ["element", "disabled"]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["column", _ctx.size]),
              key: element.id
            }, [
              (_ctx.isElementList(element))
                ? (_openBlock(), _createBlock(_component_ElementThumbnail, {
                    key: 0,
                    element: element,
                    disabled: _ctx.disabled,
                    dataset: _ctx.dataset,
                    set: _ctx.set
                  }, null, 8, ["element", "disabled", "dataset", "set"]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]))
}